import {OptionsObject, SnackbarMessage, useSnackbar} from "notistack";

export const useNotification = ()  => {
    const { enqueueSnackbar, ...rest } = useSnackbar();
    return {
        error: (message: SnackbarMessage, options: OptionsObject = {}) => {
            return enqueueSnackbar(message, {
                ...options,
                variant: "error",
            });
        },
        info: (message: SnackbarMessage, options: OptionsObject = {}) => {
            return enqueueSnackbar(message, {
                ...options,
                variant: "info",
            });
        },
        success: (message: SnackbarMessage, options: OptionsObject = {}) => {
            return enqueueSnackbar(message, {
                ...options,
                variant: "success",
            });
        },
        warning: (message: SnackbarMessage, options: OptionsObject = {}) => {
            return enqueueSnackbar(message, {
                ...options,
                variant: "warning",
            });
        },
        enqueueSnackbar,
        ...rest,
    }
};